module.exports = __webpack_public_path__ + "img/Size=64, Style=regular.a0fc2386.svg";